import React from 'react';

export function ErrorNotice({ message }: { message: string }) {
  return <div className="mb-4 bg-red-600/20 text-red-400 px-4 py-2 rounded text-sm">{message}</div>;
}
